export const verifyEmailStepSX = {
    heading: {
        fontSize: "30px",
        p: 2
    },

    contentWrapper: {
        p: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
    },

    messageBox: {
        pt: 2,
        pb: 2
    },

    messageText: {
        textDecoration: "none",
        fontSize: "16px",
        textAlign: "center"
    },

    emailText: {
        textDecoration: "none",
        fontSize: "16px",
        textAlign: "center",
        fontWeight: "900",
        paddingTop: "4px"
    },

    resendWrapper: {
        pt: 2,
        pb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "200px"
    },

    footerText: {
        textDecoration: "none",
        fontSize: "16px",
        textAlign: "center",
        paddingTop: "20px"
    }
};
